// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Select from "../../resources/selection-and-input/Select.res.js";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as DeviceName from "./DeviceName.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as ReactUpdateEffect from "../../primitives/ReactUpdateEffect.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query DevicesQuery  {\ndevices(first: 50)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nname  \nslug  \nshop  {\n__typename  \nid  \n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.devices;
  let value$2 = value$1.edges;
  return {
    devices: {
      __typename: value$1.__typename,
      edges: value$2.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.shop;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            name: value$1.name,
            slug: value$1.slug,
            shop: {
              __typename: value$2.__typename,
              id: value$2.id
            }
          }
        };
      })
    }
  };
}

function serialize(value) {
  let value$1 = value.devices;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.shop;
    let value$3 = value$2.id;
    let value$4 = value$2.__typename;
    let shop = {
      __typename: value$4,
      id: value$3
    };
    let value$5 = value$1.slug;
    let value$6 = value$1.name;
    let value$7 = value$1.id;
    let value$8 = value$1.__typename;
    let node = {
      __typename: value$8,
      id: value$7,
      name: value$6,
      slug: value$5,
      shop: shop
    };
    let value$9 = value.__typename;
    return {
      __typename: value$9,
      node: node
    };
  });
  let value$3 = value$1.__typename;
  let devices = {
    __typename: value$3,
    edges: edges
  };
  return {
    devices: devices
  };
}

function serializeVariables() {
  
}

function makeVariables() {
  
}

function makeDefaultVariables() {
  
}

let Query_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  makeDefaultVariables: makeDefaultVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let Query_refetchQueryDescription = include.refetchQueryDescription;

let Query_useLazy = include.useLazy;

let Query_useLazyWithVariables = include.useLazyWithVariables;

let Query = {
  Query_inner: Query_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: Query_refetchQueryDescription,
  use: use,
  useLazy: Query_useLazy,
  useLazyWithVariables: Query_useLazyWithVariables
};

function sortedCashRegistersFromDevicesEdges(edges, shopId) {
  return Stdlib_Array.filterMap(edges, param => {
    let device = param.node;
    let cashRegister = DeviceName.decode(device.slug, device.name);
    if (typeof cashRegister !== "object" || shopId !== device.shop.id) {
      return;
    } else {
      return {
        id: device.id,
        label: DeviceName.format(cashRegister)
      };
    }
  }).toSorted((current, next) => current.label.localeCompare(next.label));
}

function servicesFromDevicesEdges(edges, shopId) {
  return Stdlib_Array.filterMap(edges, param => {
    let device = param.node;
    let service = DeviceName.decode(device.slug, device.name);
    if (typeof service === "object") {
      return;
    }
    switch (service) {
      case "DashboardWinoFr" :
      case "WinoPay" :
        break;
      default:
        return;
    }
    if (shopId === device.shop.id) {
      return {
        id: device.id,
        label: DeviceName.format(service)
      };
    }
  });
}

function useQueryAsyncResultFn() {
  return ApolloHelpers.queryResultToAsyncResult(use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined));
}

function DeviceSelect(props) {
  let onChange = props.onChange;
  let __requestDevicesAsyncResult = props.requestDevicesAsyncResult;
  let value = props.value;
  let shopId = props.shopId;
  let __size = props.size;
  let size = __size !== undefined ? __size : "normal";
  let requestDevicesAsyncResult = __requestDevicesAsyncResult !== undefined ? __requestDevicesAsyncResult : useQueryAsyncResultFn;
  let devicesAsyncResult = requestDevicesAsyncResult();
  ReactUpdateEffect.use1(() => {
    onChange([]);
  }, [shopId]);
  let match;
  if (typeof devicesAsyncResult !== "object") {
    match = [
      [],
      []
    ];
  } else if (devicesAsyncResult.TAG === "Done") {
    let match$1 = devicesAsyncResult._0;
    if (match$1.TAG === "Ok") {
      if (shopId !== undefined) {
        let edges = match$1._0.devices.edges;
        let cashRegisters = sortedCashRegistersFromDevicesEdges(edges, shopId);
        let services = servicesFromDevicesEdges(edges.filter(param => {
          let node = param.node;
          return DeviceName.decode(node.slug, node.name) !== "DashboardWinoFr";
        }), shopId);
        match = [
          cashRegisters,
          services
        ];
      } else {
        match = [
          [],
          []
        ];
      }
    } else {
      match = [
        [],
        []
      ];
    }
  } else {
    match = [
      [],
      []
    ];
  }
  let toItem = device => ({
    TAG: "Option",
    key: device.id,
    label: device.label,
    value: device
  });
  let sections = [
    {
      items: [{
          TAG: "Option",
          key: "__all__",
          label: I18n.t("All"),
          value: undefined,
          exclusive: true
        }]
    },
    {
      items: match[0].map(toItem),
      title: I18n.t("Cash registers")
    },
    {
      items: match[1].map(toItem),
      title: I18n.t("Services")
    }
  ];
  let onSelectionChange = selection => {
    if (selection.TAG === "Single") {
      return;
    } else {
      return onChange(Stdlib_Array.filterMap(selection._0, value => value));
    }
  };
  return JsxRuntime.jsx(Tooltip.make, {
    children: JsxRuntime.jsx(Select.make, {
      label: I18n.t("Device"),
      placeholder: I18n.t("Select a device"),
      preset: "filter",
      size: size,
      highlighted: value.length !== 0,
      disabled: Stdlib_Option.isNone(shopId),
      sections: sections,
      value: {
        TAG: "Multiple",
        _0: value.length !== 0 ? value.map(device => device) : [undefined]
      },
      onChange: onSelectionChange
    }),
    placement: "top",
    content: JsxRuntime.jsx(Tooltip.Span.make, {
      text: I18n.t("Please select a shop beforehand.")
    }),
    disabled: Stdlib_Option.isSome(shopId),
    delay: 350
  });
}

let make = React.memo(DeviceSelect);

export {
  Query,
  sortedCashRegistersFromDevicesEdges,
  servicesFromDevicesEdges,
  useQueryAsyncResultFn,
  make,
}
/* query Not a pure module */
